// extracted by mini-css-extract-plugin
module.exports = {"table":"list_table__1-j2p","pull-right":"list_pull-right__1bUw9","type":"list_type__3mIDu"};